import BureauKycConsentV2 from './BureauKycConsentV2';

// V2-only. The legacy Slate-based BureauKycConsentEditor (V1) was removed; this
// now always renders the Plate-based BureauKycConsentV2. The
// `editor.bureauKycConsent.v2` key is retained in visibilityKeys.ts for
// reference/revert but is no longer read.
function BureauKycConsent() {
    return <BureauKycConsentV2 />;
}

export default BureauKycConsent;
